/* ══════════════════════════════════════════
   LOV·HER — Custom JS
   ══════════════════════════════════════════

   Sections :
   1. Reveal animations (global)
   2. Price updater (quantity × unit)
   3. One-time product page patches (accordéons + bouton Lov.Cup)
   4. Bundle Pumper patches (async)
   5. Observer & retry timers
*/


/* ── 1. REVEAL ANIMATIONS (global, robust) ── */
(function(){
  // Drapeau lu par le failsafe inline dans <head> : tant qu'il est vrai, le
  // reveal JS tourne et le failsafe ne fait rien. S'il reste absent (ce fichier
  // n'a pas chargé), le failsafe révèle tout le contenu après 5s.
  window.__lovherRevealActive = true;

  var revealObs;
  function initReveal() {
    if (!revealObs) {
      revealObs = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('lovher-in');
            revealObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
    }
    document.querySelectorAll('.lovher-reveal:not(.lovher-in)').forEach(function(el) {
      revealObs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
  // Filets pour le contenu rendu tardivement (sections lazy). Bornés et bon marché.
  setTimeout(initReveal, 500);
  setTimeout(initReveal, 1500);
  setTimeout(initReveal, 3000);

  // Avant : un MutationObserver permanent sur tout le document relançait un
  // querySelector full-doc à CHAQUE mutation (Klaviyo, Pumper, prix…) pour
  // chaque visiteur → jank/TBT. Son seul vrai besoin = recâbler les sections
  // ajoutées/réordonnées dans l'éditeur de thème → on s'y limite via designMode.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initReveal);
    document.addEventListener('shopify:section:reorder', initReveal);
  }
})();


/* ── 2. PRICE UPDATER (qty × unit price display) ── */
function initPriceUpdater() {
  document.querySelectorAll('.product-info__block-list').forEach(function(block) {
    const qtyInput = block.querySelector('.quantity-selector__input');
    const salePrice = block.querySelector('sale-price');
    if (!qtyInput || !salePrice || qtyInput.dataset.priceInit) return;

    const unitPrice = parseFloat(
      salePrice.textContent.trim().replace(/[^\d,]/g, '').replace(',', '.')
    );
    if (isNaN(unitPrice)) return;

    qtyInput.dataset.priceInit = 'true';

    const totalEl = document.createElement('span');
    totalEl.className = 'lovher-price-total h4 text-on-sale';
    totalEl.style.cssText = 'display:none;color:#fd2d94;font-weight:700;margin-left:4px;';
    salePrice.parentNode.insertBefore(totalEl, salePrice.nextSibling);

    function updateTotal() {
      const qty = parseInt(qtyInput.value) || 1;
      if (qty > 1) {
        const total = (unitPrice * qty).toFixed(2).replace('.', ',');
        totalEl.textContent = total + '\u20ac';
        totalEl.style.display = 'inline';
        salePrice.style.display = 'none';
      } else {
        totalEl.style.display = 'none';
        salePrice.style.display = '';
      }
    }

    const buttons = block.querySelectorAll('.quantity-selector__button');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(updateTotal, 50);
      });
    });

    qtyInput.addEventListener('input', updateTotal);
    qtyInput.addEventListener('change', updateTotal);

    const priceObserver = new MutationObserver(updateTotal);
    priceObserver.observe(qtyInput, { attributes: true, attributeFilter: ['value'] });
  });
}

document.addEventListener('DOMContentLoaded', initPriceUpdater);
setTimeout(initPriceUpdater, 800);


/* ── 3. ONE-TIME PRODUCT PAGE PATCHES ── */
function lovherProductPagePatches() {

  // 3.1. Texte accordéons en 14px
  document.querySelectorAll('.accordion-group li, .accordion-group p').forEach(function(el) {
    if (el.dataset.fontPatched) return;
    el.style.fontSize = '14px';
    el.style.lineHeight = '1.5';
    el.dataset.fontPatched = 'true';
  });

  // 3.2. Déplacer les accordéons sous le bloc product entier
  const accordion = document.querySelector('.accordion-group');
  const product = document.querySelector('.product');
  if (accordion && product && !accordion.dataset.moved) {
    product.parentElement.insertBefore(accordion, product.nextSibling);
    accordion.style.cssText = 'max-width:1200px; margin:0 auto; padding:0 20px;';
    accordion.dataset.moved = 'true';
  }

  // 3.3. Bouton d'achat Lov.Cup (sélecteur stable par URL)
  const isLovCupPage = /\/products\/lov-cup(?:$|\?|\/)/.test(window.location.pathname);
  if (isLovCupPage) {
    const btnNatif = document.querySelector('.product-info .button[type="submit"]');
    if (btnNatif && !btnNatif.dataset.patched) {
      btnNatif.textContent = "J'adopte la LOV.Cup →";
      btnNatif.dataset.patched = 'true';
    }
  }
}

document.addEventListener('DOMContentLoaded', lovherProductPagePatches);
setTimeout(lovherProductPagePatches, 500);


/* ── 4. BUNDLE PUMPER PATCHES (async — Pumper se charge après le DOM) ── */
function lovherPatchBundle() {

  // 4.1. Bouton bundle
  const btn = document.querySelector('.pmpr_bundle__add_to_cart');
  if (btn && !btn.dataset.patched) {
    btn.textContent = "J'adopte le Duo →";
    btn.dataset.patched = 'true';
  }

  // 4.2. Footer bundle (colonne unique centrée + badge DUO + prix)
  const buyAll = document.querySelector('.pmpr_bundle__buy_all');
  if (buyAll && !buyAll.dataset.patched) {
    const discountText = buyAll.querySelector('.pmpr_bundle__footer_text')?.textContent?.trim() || '';
    const comparePrice = buyAll.querySelector('.pmpr_bundle__compare_price_text')?.textContent?.trim() || '';
    const totalPrice   = buyAll.querySelector('.pmpr_bundle__total_price_text')?.textContent?.trim() || '';

    buyAll.innerHTML = `
      <div style="display:flex;flex-direction:column;align-items:center;text-align:center;gap:6px;width:100%;padding:12px 0;">
        <div style="background:#FD2D94;color:#fff;font-size:11px;font-weight:700;border-radius:20px;padding:3px 12px;letter-spacing:0.04em;">DUO</div>
        <div style="color:#1A1A1A;font-size:13px;font-weight:700;">${discountText}</div>
        <div style="display:flex;align-items:center;gap:8px;">
          <span style="color:#AAAAAA;font-size:13px;text-decoration:line-through;">${comparePrice}</span>
          <span style="color:#FD2D94;font-size:22px;font-weight:700;">${totalPrice}</span>
        </div>
        <div style="color:#2D9B5A;font-size:12px;font-weight:600;">✓ Vous économisez 5€ sur ce duo</div>
      </div>
    `;
    buyAll.style.cssText = 'background:#FFF0F5;border-top:1px solid #FFD6E8;padding:0 16px;';
    buyAll.dataset.patched = 'true';
  }

  // 4.3. Fix coupure titres bundle
  document.querySelectorAll('.pmpr_bundle__product_name_text').forEach(function(el) {
    if (el.dataset.wrapPatched) return;
    el.style.cssText += 'font-size:12px;line-height:1.4;word-break:normal;hyphens:none;';
    el.dataset.wrapPatched = 'true';
  });

  // 4.4. Gras sur le nom produit uniquement (avant le "—")
  document.querySelectorAll('.pmpr_bundle__product_name_text').forEach(function(el) {
    if (el.dataset.boldPatched) return;
    const text = el.textContent.trim();
    const parts = text.split('—');
    if (parts.length >= 2) {
      el.innerHTML = `<strong>${parts[0].trim()}</strong> — ${parts.slice(1).join('—').trim()}`;
    } else {
      el.style.fontWeight = '700';
    }
    el.dataset.boldPatched = 'true';
  });

  // 4.5. Séparateur visuel avant le bloc bundle
  const pumper = document.querySelector('.pmpr_bundle__root');
  if (pumper && !document.querySelector('.lovher-bundle-separator')) {
    const separator = document.createElement('div');
    separator.className = 'lovher-bundle-separator';
    separator.style.cssText = 'display:flex;align-items:center;gap:12px;margin:16px 0 8px;';
    separator.innerHTML = `
      <div style="flex:1;height:1px;background:#FFD6E8;"></div>
      <div style="color:#FD2D94;font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;white-space:nowrap;">✨ Profitez du Duo</div>
      <div style="flex:1;height:1px;background:#FFD6E8;"></div>
    `;
    pumper.parentElement.insertBefore(separator, pumper);
  }
}


/* ── 5. OBSERVER + RETRY TIMERS (trigger bundle patches once Pumper loads) ── */
(function(){
  // Le bundle Pumper n'existe que sur les pages produit. Avant, cet observer
  // surveillait tout le body EN PERMANENCE sur CHAQUE page (home, collections,
  // blog…) à vide → on le limite aux pages produit.
  if (!/\/products\//.test(window.location.pathname)) return;

  // Retry timers : au cas où le DOM est déjà prêt ou Pumper arrive sans mutation notable
  setTimeout(lovherPatchBundle, 500);
  setTimeout(lovherPatchBundle, 1500);
  setTimeout(lovherPatchBundle, 3000);

  // Observer : déclenche les patches dès que Pumper injecte ses éléments
  const bundleObserver = new MutationObserver(function() {
    if (document.querySelector('.pmpr_bundle__add_to_cart')) {
      setTimeout(lovherPatchBundle, 150);
    }
  });
  bundleObserver.observe(document.body, { childList: true, subtree: true });
})();